var map = {
	"./chicken-satay-lettuce-wraps/recipe": 3308,
	"./chili-garlic-spicy-noodles/recipe": 3474,
	"./dak-galbi/recipe": 46,
	"./detroit-style-pizza/recipe": 5749,
	"./eggplant-parmesan/recipe": 6265,
	"./lavash-triangles/recipe": 1022,
	"./pasta-amatriciana/recipe": 9373,
	"./samoas-cookies/recipe": 1184,
	"./springtime-saffron-pasta/recipe": 9924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3795;